import React from "react";
import { RadioSelector } from "../../../components/Forms/RadioSelector";
import { Typography } from "@material-ui/core";

const types = [
  {
    name: "Normal",
    value: "Normal",
    helperText: "All reads that are not first or last reads",
  },
  {
    name: "First",
    value: "First",
    helperText:
      "Opening read for a new supply or the first read after a meter exchange",
  },
  {
    name: "Last",
    value: "Last",
    helperText:
      "Final read before a supply loss or the last read before a meter exchange",
  },
];

type SequenceTypeProps = {
  name?: string;
};
export const SequenceType: React.FC<SequenceTypeProps> = ({
  name = "sequenceType",
}) => {
  return (
    <>
      <Typography variant="body1">Sequence type</Typography>
      <RadioSelector
        name={name}
        options={types}
        controllerProps={{
          defaultValue: "Normal",
        }}
        radioProps={{
          "data-testid": "SequenceType__RadioGroup",
        }}
      />
    </>
  );
};
